<template>
<div class="comment">
	<div class="main" v-if="commentCount !== 0">
		<div class="title">综合评分</div>
		<div class="info">
			<div class="score">
				<!-- 保留一位小数 -->
				<div class="score-num">{{ avgStar.toFixed(1) }}分</div>
			</div>
			<!-- 五角星 -->
			<div class="star">
				<div class="star-txt">综合评分</div>
				<van-rate v-model="avgStar" :icon="IcBright" :void-icon="IcBrightNo" size="12px" readonly/>
			</div>
			<div class="people">
				<div class="people-txt">全部评价</div>
				<div class="people-num">（{{ commentCount }}）</div>
			</div>
		</div>
	</div>
	<!-- 评论列表 -->
	<div class="list" v-if="commentCount !== 0">
		<div class="title">评论列表</div>
		<van-list
				v-model="loading"
				:finished="finished"
				finished-text="没有更多了"
				@load="onLoad"
		>
			<div class="list-item" v-for="item in commentList" :key="item.id">
			<div class="item-top">
				<van-image :src="item.avatarUrl" lazy-load round />
				<div class="item-info">
					<div class="name van-ellipsis">{{ item.nickName }}</div>
					<div class="time">
						<van-rate v-model="item.star" :icon="IcBright" :void-icon="IcBrightNo" size="12px" readonly/>
						<span>{{ item.commentTime }}</span>
					</div>
				</div>
			</div>
			<div class="item-content">
				<MultiLineExpandsCollapses :id="'comment'+item.id" :content="item.comment"/>
			</div>
		</div>
		</van-list>
	</div>
	<div class="no-box"  v-else>
		<div class="title">评论列表</div>
		<div class="no-data">
			<img :src="NoComment" alt="">
			<span>暂无评论内容～</span>
		</div>
	</div>
</div>
</template>

<script>
import { getImageUrl,isHttp } from "@/utils/upload";
import http from '@/utils/http'
import NoComment from "@/assets/image/learning/no_comment.png";
import MultiLineExpandsCollapses from "@/page/details/components/MultiLineExpandsCollapses.vue";
import IcBright from "@/assets/image/learning/ic_bright.png";
import IcBrightNo from "@/assets/image/learning/ic_bright_no.png";
export default {
	components: {
		MultiLineExpandsCollapses
	},
	data() {
		return {
			commentList:[], // 评论列表
			loading: false,
			finished: false,
			page: 1,
			pageSize: 10,
			avgStar: 0, // 平均分
			commentCount: 0, // 评论总数
			NoComment: NoComment,
			IcBright: IcBright,
			IcBrightNo: IcBrightNo
		};
	},
	props: {
		// 培训计划id或者课程id
		trainId: {
			type: String,
			default: "0"
		},
		// 类型
		type: {
			type: Number,
			default: 1
		}
	},
	created() {
		this.getCommentList();
	},
	methods: {
		getCommentList(){
			// 请求接口/app/cTrain/train/detail
			let formData = new FormData();
			formData.append('api', 'kc/app/cTrain/comment/list');
			formData.append('resourceId', this.trainId);
			formData.append('type', this.type);
			formData.append('page', this.page);
			formData.append('pageSize', this.pageSize);
			http({
				url: '/ipd/commonApi',
				method: 'post',
				data: formData
			}).then(res => {
				if(res.code === 0){
					this.avgStar = res.data.avgStar;
					this.commentCount = res.data.commentCount;
					// 关闭加载
					this.loading = false;
					if (this.commentList.length >= this.commentCount) return (this.finished = true);
					this.commentList.push(...(res.data.items || []));
					this.page = this.page + 1;
					// 处理展开按钮
					if(this.commentList && this.commentList.length > 0){
						for(let v of this.commentList){
							this.$set(v,'isOpen',false);
						}
					}
					// 处理头像
					this.commentList.forEach((item) => {
						if(item.avatar && !isHttp(item.avatar)){
							getImageUrl(item.avatar,(imgUrl)=>{
								item.avatarUrl = imgUrl;
							})
						}else{
							item.avatarUrl = item.avatar;
						}
					});
				}
			}).finally(()=>{
				this.loading = false;
			})
		},
		// 加载更多
		onLoad() {
			this.getCommentList();
		}
	},
}
</script>

<style scoped lang="css">
*{
	box-sizing: border-box;
}
.comment{
	width: 100%;
	padding:  17px 15px 15px;
	background: #FFFFFF;
}
.main{
	margin-bottom: 20px;
}
.title{
	font-weight: 600;
	font-size: 17px;
	color: #333333;
	margin-bottom: 10px;
}
.info{
	display: flex;
	align-items: center;
	height: 70px;
	background: #FFF6F6;
	border-radius: 4px;
	padding: 0 20px 0;
}
.info .score .score-num{
	font-size: 30px;
	color: #F7443F;
	font-weight: 600;
}
.info .score{
	padding-right: 15px;
	border-right: 1px solid #F7443F;
}
.info .star{
	display: flex;
	flex-direction: column;
	margin-left: 15px;
}
.info .star .star-txt{
	font-size: 13px;
	color: #555555;
	margin-bottom: 3px;
}
.info .people{
	display: flex;
	flex-direction: column;
	margin-left: auto;
}
.people-txt{
	font-size: 13px;
	color: #555555;
	margin-bottom: 3px;
}
.people-num{
	font-weight: 600;
	font-size: 14px;
	color: #333333;
	text-align: center;
}
.list{
	width: 100%;
}
.list-item{
	width: 100%;
	display: flex;
	flex-direction: column;
	border-bottom: 1px solid #F0F0F0;
	margin-top: 15px;
	padding-bottom: 11px;
}
.item-top{
	width: 100%;
	display: flex;
	margin-bottom: 8px;
}
.item-top .van-image{
	width: 34px;
	height: 34px;
	margin-right: 11px;
	border-radius: 50%;
}
.item-top .item-info{
	width: 86%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.item-info .name{
	font-size: 14px;
	color: #333333;
	font-weight: 600;
}
.item-info .time{
	display: flex;
	align-items: center;
	font-size: 12px;
	color: #9B9B9B;
}
.item-info .time span{
	margin-left: 10px;
}
.item-content {
	display: flex;
	font-size: 14px;
	color: #555555;
}
.no-data{
	align-self: center;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 40px 0 10px;
	font-weight: 400;
	font-size: 13px;
	color: #C0C4CC;
}
.no-data img{
	width: 113px;
	height: 113px;
	margin-bottom: 5px;
}
</style>